import { useEffect, useState } from "react";

const navItems = [
  { label: "首页", href: "#top" },
  { label: "栏目分类", href: "#categories" },
  { label: "热门漫画", href: "#featured" },
  { label: "阅读特色", href: "#features" },
  { label: "精选阅读", href: "#reading" },
  { label: "读者口碑", href: "#testimonials" },
  { label: "常见问题", href: "#faq" },
];

function Logo({ onDark }: { onDark: boolean }) {
  return (
    <a href="#top" className="flex items-center gap-2.5 shrink-0" aria-label="纸盒漫画网 首页">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 shadow-paper">
        <i className="ri-box-3-fill text-lg leading-none" aria-hidden="true"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-lg tracking-wide ${
            onDark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          纸盒漫画网
        </span>
        <span
          className={`mt-0.5 text-[10px] tracking-[0.22em] ${
            onDark ? "text-background-50/80" : "text-foreground-500"
          }`}
        >
          PAPER BOX COMICS
        </span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const pinned = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        pinned
          ? "bg-background-50/95 backdrop-blur-md shadow-paper"
          : "bg-transparent"
      }`}
    >
      <div className="container-paper">
        <nav className="flex h-16 items-center justify-between gap-4 md:h-[76px]">
          <Logo onDark={!pinned} />

          {/* 桌面导航 */}
          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  pinned
                    ? "text-foreground-700 hover:bg-background-200 hover:text-primary-700"
                    : "text-background-50/90 hover:bg-background-50/10 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden items-center gap-3 lg:flex">
            <a
              href="#about"
              className={`text-sm whitespace-nowrap transition-colors ${
                pinned
                  ? "text-foreground-700 hover:text-primary-700"
                  : "text-background-50/90 hover:text-background-50"
              }`}
            >
              关于纸盒
            </a>
            <a
              href="#subscribe"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line text-base leading-none" aria-hidden="true"></i>
              开始阅读
            </a>
          </div>

          {/* 移动端汉堡 */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              pinned
                ? "text-foreground-800 hover:bg-background-200"
                : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i
              className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl leading-none`}
              aria-hidden="true"
            ></i>
          </button>
        </nav>
      </div>

      {/* 移动端菜单面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="container-paper py-3">
            <div className="grid grid-cols-2 gap-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-200"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#about"
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-200"
              >
                关于纸盒
              </a>
            </div>
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-book-open-line text-base leading-none" aria-hidden="true"></i>
              开始阅读
            </a>
          </div>
        </div>
      )}
    </header>
  );
}